module.exports = __webpack_public_path__ + "img/05-top-img@2x.171a457b.png";